// Copyright (c) StrangeBee 2023

import { useLocalMessage } from '@Helpers/locale';
import { THButton } from '@Molecules/Inputs/THButton/THButton';
import { THPopConfirm } from '@Molecules/Inputs/THPopConfirm/THPopConfirm';
import { DashboardEventList } from '@Organisms/Dashboard/eventList';
import React, { useMemo } from 'react';
import { DashboardOutput } from 'thehive-sdk';

interface DashboardCacheProps {
    eventList: DashboardEventList;
    dashboard: DashboardOutput;
}

export const DashboardCache = ({ eventList, dashboard }: DashboardCacheProps) => {
    const i = useLocalMessage();

    const cache = useMemo(() => dashboard.definition.cache, [dashboard.definition.cache]);

    const onFinish = () => {
        eventList.onEdit(
            {
                ...dashboard,
                definition: {
                    ...dashboard.definition,
                    cache: !cache,
                },
            },
            dashboard._id,
        );
    };

    return (
        <THPopConfirm
            title={cache ? i('dashboard.cache.disable-confirm') : i('dashboard.cache.enable-confirm')}
            onConfirm={onFinish}
        >
            <THButton type="default">{cache ? i('dashboard.cache.disable') : i('dashboard.cache.enable')}</THButton>
        </THPopConfirm>
    );
};
